export interface MaritalStatus {
  value: string | undefined;
  label: string;
}

export const MaritalStatus: Array<MaritalStatus> = [
  {
    value: undefined,
    label: "Select marital status",
  },
  {
    value: "married",
    label: "Married",
  },
  {
    value: "single",
    label: "Single",
  },
  {
    value: "separated",
    label: "Separated",
  },
  {
    value: "divorced",
    label: "Divorced",
  },
  {
    value: "widowed",
    label: "Widowed",
  },
];
